import { render } from "./footer.html?vue&type=template&id=28c2c8f8&ts=true"
import script from "./footer.vue?vue&type=script&lang=ts"
export * from "./footer.vue?vue&type=script&lang=ts"

import "./footer.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\mt7rk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__